// Static landing page is served from /public/index.html.
// React app intentionally renders nothing so the static HTML remains untouched.
function App() {
  return null;
}

export default App;
